import { useTranslation } from "react-i18next";
import {
  FileText,
  FileSearch,
  Search,
  FileCheck,
  Scale,
  Library,
  PenLine,
  Languages,
} from "lucide-react";

const features = [
  { key: "memorandums", icon: FileText },
  { key: "contracts", icon: FileSearch },
  { key: "research", icon: Search },
  { key: "summary", icon: FileCheck },
  { key: "litigation", icon: Scale },
  { key: "knowledge", icon: Library },
  { key: "review", icon: PenLine },
  { key: "bilingual", icon: Languages },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section
      id="features"
      className="py-24 md:py-32 scroll-mt-20"
      style={{ backgroundColor: "var(--landing-bg)" }}
    >
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: "var(--landing-text)" }}
          >
            {t("features.title")}
          </h2>
          <p
            className="text-lg leading-relaxed"
            style={{ color: "var(--landing-text-secondary)" }}
          >
            {t("features.subtitle")}
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map(({ key, icon: Icon }) => (
            <div
              key={key}
              className="landing-card p-6 rounded-2xl"
            >
              <div
                className="flex items-center justify-center w-12 h-12 rounded-xl mb-4"
                style={{ backgroundColor: "var(--landing-surface-alt)" }}
              >
                <Icon className="h-6 w-6" style={{ color: "var(--landing-primary)" }} />
              </div>
              <h3
                className="font-semibold text-lg mb-2"
                style={{ color: "var(--landing-text)" }}
              >
                {t(`feature.${key}`)}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ color: "var(--landing-text-secondary)" }}
              >
                {t(`feature.${key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
